import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyFocusPointDialog = loadable(() => import(/* webpackChunkName: "content/guest/aloha/focusPointDialog" */ './FocusPointDialog'), 'FocusPointDialog');
